import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { AuthService } from '../../firebase/authService';
import ExploreIcon from '@mui/icons-material/Explore';

const DemoBanner: React.FC = () => {
  const { user, organization } = useSelector((state: RootState) => state.auth);

  const isGuest = user?.userEmail === '' && !organization;

  if (!isGuest) return null;

  const handleSignUp = async () => {
    await AuthService.signOut();
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        top: '64px',
        left: '60px',
        right: 0,
        zIndex: 1099,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        py: 1,
        px: 2,
        background: 'linear-gradient(135deg, #0277bd 0%, #00838f 100%)',
        color: '#fff',
        boxShadow: '0 2px 4px rgba(0,0,0,0.15)',
      }}
    >
      <ExploreIcon fontSize="small" />
      <Typography variant="body2" sx={{ fontWeight: 500 }}>
        You're exploring a demo. Sign up to save your inventory.
      </Typography>
      <Button
        variant="outlined"
        size="small"
        onClick={handleSignUp}
        sx={{
          color: '#fff',
          borderColor: 'rgba(255,255,255,0.7)',
          textTransform: 'none',
          fontWeight: 600,
          '&:hover': {
            borderColor: '#fff',
            backgroundColor: 'rgba(255,255,255,0.12)',
          },
        }}
      >
        Sign Up
      </Button>
    </Box>
  );
};

export default DemoBanner;
